import { useEffect, useState } from 'react';
import { FormikErrors } from 'formik/dist/types';

export type AppFormValidationEffectProps<DATA extends {}> = {
  errors?: FormikErrors<DATA>;
  onValidation?(isValid: boolean, errors?: FormikErrors<DATA>): void;
};

export function AppFormValidationEffect<DATA extends {}>({ onValidation, errors }: AppFormValidationEffectProps<DATA>) {
  const [previousErrors, setPreviousErrors] = useState<FormikErrors<DATA>>();

  useEffect(() => {
    if (JSON.stringify(previousErrors) !== JSON.stringify(errors)) {
      onValidation?.(Object.keys(errors ?? {}).length === 0, errors);
      setPreviousErrors(errors);
    }
  }, [onValidation, previousErrors, errors]);

  return null;
}
